import { LinkListItem } from "../../../components/link-list";
import FetchSettings from "../../interfaces/FetchSettings";
import OcontentProvider from "./OcontentProvider";

export default class OcontentQuicklinsProvider extends OcontentProvider {
  protected _baseUrl = this.baseUrl + "quick-links/";

  async getQuicklinks(name: string): Promise<LinkListItem[]> {
    try {
      const url = new URL(this._baseUrl + name + ".json");
      const settings: FetchSettings = {
        method: "GET",
      };

      const res = await this.request<Response>(url.toString(), settings, true);
      console.log(res);
      if (res.ok) {
        return await res.json();
      }
    } catch (err) {
      console.error(err);
    }
    return [];
  }
}
